var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	9771: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_index_js")]).then(() => (() => (__webpack_require__(1340))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	3235: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__untracked-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__debug_node-chunk_mjs"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(453))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	4315: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js")]).then(() => (() => (__webpack_require__(3620))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	8573: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_common_mjs")]).then(() => (() => (__webpack_require__(1352))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	2377: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_http_mjs")]).then(() => (() => (__webpack_require__(6613))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	5211: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__untracked-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022_rxjs-interop_mjs")]).then(() => (() => (__webpack_require__(9074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	6647: {
		fallback: () => (__webpack_require__.e("default-node_modules_ngrx_signals_fesm2022_ngrx-signals_mjs").then(() => (() => (__webpack_require__(1803))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/signals",

	},
	8605: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(3095))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/signals/events",

	},
	7913: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(4909))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/signals/entities",

	},
	203: {
		fallback: () => (Promise.all([__webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_core_fesm2022__linked_signal-chunk_mjs-_246a0")]).then(() => (() => (__webpack_require__(6699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	7775: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(8513))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	953: {
		fallback: () => (__webpack_require__.e("default-node_modules_angular_animations_fesm2022_browser_mjs").then(() => (() => (__webpack_require__(1887))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations/browser",

	},
	9476: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022__browser-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022_platform-browser_mjs")]).then(() => (() => (__webpack_require__(436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	6289: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_angular_router_fesm2022_router_mjs")]).then(() => (() => (__webpack_require__(7415))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	3960: {
		fallback: () => (__webpack_require__.e("node_modules_azure_msal-browser_dist_index_mjs").then(() => (() => (__webpack_require__(9676))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.2.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@azure/msal-browser",

	},
	803: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-node_modules_jsverse_transloco_fesm2022_jsverse-transloco_mjs")]).then(() => (() => (__webpack_require__(8065))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^8.2.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@jsverse/transloco",

	},
	1110: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-licensing_progress_kendo-licensing"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-common_progress_kendo-angular-common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_progress_kendo-angular-icons_fesm2022_progress-kendo-angular-icons_mjs")]).then(() => (() => (__webpack_require__(1039))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-icons",

	},
	8587: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-licensing_progress_kendo-licensing"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-common_progress_kendo-angular-common"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-l10n_progress_kendo-angular-l10n"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-svg-icons_progress_kendo-svg-icons"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-icons_progress_kendo-angular-icons"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_animations_angular_animations"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-popup_progress_kendo-angular-popup"), __webpack_require__.e("default-node_modules_progress_kendo-angular-buttons_fesm2022_progress-kendo-angular-buttons_mjs")]).then(() => (() => (__webpack_require__(7881))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-buttons",

	},
	1646: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-licensing_progress_kendo-licensing"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-common_progress_kendo-angular-common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_animations_angular_animations"), __webpack_require__.e("default-node_modules_progress_kendo-popup-common_dist_es_main_js"), __webpack_require__.e("default-node_modules_progress_kendo-angular-popup_fesm2022_progress-kendo-angular-popup_mjs")]).then(() => (() => (__webpack_require__(5403))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-popup",

	},
	7624: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-licensing_progress_kendo-licensing"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-common_progress_kendo-angular-common"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-l10n_progress_kendo-angular-l10n"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-svg-icons_progress_kendo-svg-icons"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-icons_progress_kendo-angular-icons"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-buttons_progress_kendo-angular-630eef"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_animations_angular_animations"), __webpack_require__.e("default-node_modules_progress_kendo-popup-common_dist_es_main_js"), __webpack_require__.e("default-node_modules_progress_kendo-angular-dialog_fesm2022_progress-kendo-angular-dialog_mjs")]).then(() => (() => (__webpack_require__(8579))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-dialog",

	},
	4634: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-licensing_progress_kendo-licensing"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-common_progress_kendo-angular-common"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-l10n_progress_kendo-angular-l10n"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-svg-icons_progress_kendo-svg-icons"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_animations_angular_animations"), __webpack_require__.e("default-node_modules_progress_kendo-angular-navigation_fesm2022_progress-kendo-angular-naviga-417c75")]).then(() => (() => (__webpack_require__(6351))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-navigation",

	},
	8141: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-licensing_progress_kendo-licensing"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-common_progress_kendo-angular-common"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-l10n_progress_kendo-angular-l10n"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-svg-icons_progress_kendo-svg-icons"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-buttons_progress_kendo-angular-630eef"), __webpack_require__.e("default-node_modules_angular_forms_fesm2022_forms_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-dialog_progress_kendo-angular-dialog"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-navigation_progress_kendo-angu-4f0499"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-utils_progress_kendo-angular-utils"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-intl_progress_kendo-angular-intl"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-drawing_progress_kendo-drawing"), __webpack_require__.e("default-node_modules_progress_kendo-angular-inputs_fesm2022_progress-kendo-angular-inputs_mjs")]).then(() => (() => (__webpack_require__(8368))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-inputs",

	},
	3310: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-licensing_progress_kendo-licensing"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-l10n_progress_kendo-angular-l10n"), __webpack_require__.e("default-node_modules_progress_kendo-angular-indicators_fesm2022_progress-kendo-angular-indica-faad5e")]).then(() => (() => (__webpack_require__(5255))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-indicators",

	},
	8170: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-licensing_progress_kendo-licensing"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-common_progress_kendo-angular-common"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-l10n_progress_kendo-angular-l10n"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-svg-icons_progress_kendo-svg-icons"), __webpack_require__.e("default-node_modules_angular_forms_fesm2022_forms_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-dialog_progress_kendo-angular-dialog"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-navigation_progress_kendo-angu-4f0499"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-utils_progress_kendo-angular-utils"), __webpack_require__.e("default-node_modules_progress_kendo-angular-dropdowns_fesm2022_progress-kendo-angular-dropdowns_mjs")]).then(() => (() => (__webpack_require__(4391))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-dropdowns",

	},
	6162: {
		fallback: () => (__webpack_require__.e("node_modules_progress_kendo-intl_dist_es2015_main_js").then(() => (() => (__webpack_require__(1196))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.1.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-intl",

	},
	3946: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-licensing_progress_kendo-licensing"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-common_progress_kendo-angular-common"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-l10n_progress_kendo-angular-l10n"), __webpack_require__.e("default-node_modules_progress_kendo-angular-label_fesm2022_progress-kendo-angular-label_mjs")]).then(() => (() => (__webpack_require__(1395))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-label",

	},
	1409: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-licensing_progress_kendo-licensing"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-common_progress_kendo-angular-common"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-l10n_progress_kendo-angular-l10n"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-svg-icons_progress_kendo-svg-icons"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-indicators_progress_kendo-angu-7a54fd"), __webpack_require__.e("default-node_modules_progress_kendo-angular-toolbar_fesm2022_progress-kendo-angular-toolbar_mjs")]).then(() => (() => (__webpack_require__(9111))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-toolbar",

	},
	7865: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-licensing_progress_kendo-licensing"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-common_progress_kendo-angular-common"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-l10n_progress_kendo-angular-l10n"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-svg-icons_progress_kendo-svg-icons"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-utils_progress_kendo-angular-utils"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-intl_progress_kendo-angular-intl"), __webpack_require__.e("default-node_modules_progress_kendo-angular-dateinputs_fesm2022_progress-kendo-angular-datein-a52fab")]).then(() => (() => (__webpack_require__(8519))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-dateinputs",

	},
	3326: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-licensing_progress_kendo-licensing"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-common_progress_kendo-angular-common"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-l10n_progress_kendo-angular-l10n"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-svg-icons_progress_kendo-svg-icons"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_animations_angular_animations"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-intl_progress_kendo-angular-intl"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-progressbar_progress_kendo-ang-363fe1"), __webpack_require__.e("default-node_modules_progress_kendo-angular-layout_fesm2022_progress-kendo-angular-layout_mjs")]).then(() => (() => (__webpack_require__(3479))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-layout",

	},
	4159: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-licensing_progress_kendo-licensing"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-common_progress_kendo-angular-common"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-l10n_progress_kendo-angular-l10n"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-svg-icons_progress_kendo-svg-icons"), __webpack_require__.e("default-node_modules_progress_kendo-angular-menu_fesm2022_progress-kendo-angular-menu_mjs")]).then(() => (() => (__webpack_require__(761))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-menu",

	},
	6373: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-licensing_progress_kendo-licensing"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-common_progress_kendo-angular-common"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-l10n_progress_kendo-angular-l10n"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-svg-icons_progress_kendo-svg-icons"), __webpack_require__.e("default-node_modules_progress_kendo-angular-editor_fesm2022_progress-kendo-angular-editor_mjs")]).then(() => (() => (__webpack_require__(4536))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-editor",

	},
	3349: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-licensing_progress_kendo-licensing"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-common_progress_kendo-angular-common"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-l10n_progress_kendo-angular-l10n"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-pager_progress_kendo-angular-pager"), __webpack_require__.e("default-node_modules_progress_kendo-angular-listview_fesm2022_progress-kendo-angular-listview_mjs")]).then(() => (() => (__webpack_require__(8457))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-listview",

	},
	6493: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-licensing_progress_kendo-licensing"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(7549))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-typography",

	},
	6235: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-licensing_progress_kendo-licensing"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-common_progress_kendo-angular-common"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-l10n_progress_kendo-angular-l10n"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-svg-icons_progress_kendo-svg-icons"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_animations_angular_animations"), __webpack_require__.e("default-node_modules_progress_kendo-angular-notification_fesm2022_progress-kendo-angular-noti-bb5f0d")]).then(() => (() => (__webpack_require__(1049))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-notification",

	},
	6723: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-icons_progress_kendo-angular-icons"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-buttons_progress_kendo-angular-630eef"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-popup_progress_kendo-angular-popup"), __webpack_require__.e("default-node_modules_angular_forms_fesm2022_forms_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-dialog_progress_kendo-angular-dialog"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-navigation_progress_kendo-angu-4f0499"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-inputs_progress_kendo-angular-inputs"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-indicators_progress_kendo-angu-7a54fd"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-dropdowns_progress_kendo-angul-8da06e"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-intl_progress_kendo-intl"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-label_progress_kendo-angular-l-31b8bd"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-dateinputs_progress_kendo-angu-fed2bb"), __webpack_require__.e("default-node_modules_mnp-firm-it_angular-ui-components_fesm2022_mnp-firm-it-angular-ui-compon-f35bfa")]).then(() => (() => (__webpack_require__(2264))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.2.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mnp-firm-it/angular-ui-components",

	},
	9283: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("default-webpack_sharing_consume_default_azure_msal-browser_azure_msal-browser"), __webpack_require__.e("default-node_modules_azure_msal-angular_fesm2020_azure-msal-angular_mjs")]).then(() => (() => (__webpack_require__(8653))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.0.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@azure/msal-angular",

	},
	4749: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular-architects_ngrx-toolkit_fesm2022_angular-architects-ngrx-toolkit_mjs")]).then(() => (() => (__webpack_require__(2833))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular-architects/ngrx-toolkit",

	},
	5183: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_forms_fesm2022_forms_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_ng-mocks_index_mjs")]).then(() => (() => (__webpack_require__(6706))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^14.15.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-mocks",

	},
	5797: {
		fallback: () => (__webpack_require__.e("libs_shared_models_src_index_ts").then(() => (() => (__webpack_require__(9631))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mpm/models",

	},
	5739: {
		fallback: () => (__webpack_require__.e("node_modules_progress_kendo-licensing_dist_index_mjs").then(() => (() => (__webpack_require__(3956))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.7.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-licensing",

	},
	3857: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_progress_kendo-angular-common_fesm2022_progress-kendo-angular-common_mjs")]).then(() => (() => (__webpack_require__(1137))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-common",

	},
	3541: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(4161))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-l10n",

	},
	5633: {
		fallback: () => (__webpack_require__.e("node_modules_progress_kendo-svg-icons_dist_index_es_js").then(() => (() => (__webpack_require__(7643))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.3.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-svg-icons",

	},
	7767: {
		fallback: () => (Promise.all([__webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_animations_fesm2022__private_export-chunk_mjs-_d4c51")]).then(() => (() => (__webpack_require__(7172))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations",

	},
	2807: {
		fallback: () => (__webpack_require__.e("default-node_modules_progress_kendo-angular-utils_fesm2022_progress-kendo-angular-utils_mjs").then(() => (() => (__webpack_require__(1590))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-utils",

	},
	2291: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-intl_progress_kendo-intl"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(1813))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-intl",

	},
	2776: {
		fallback: () => (__webpack_require__.e("node_modules_progress_kendo-date-math_dist_es2015_main_js").then(() => (() => (__webpack_require__(2669))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.5.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-date-math",

	},
	6145: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_animations_angular_animations"), __webpack_require__.e("default-node_modules_progress_kendo-angular-treeview_fesm2022_progress-kendo-angular-treeview_mjs")]).then(() => (() => (__webpack_require__(5701))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-treeview",

	},
	3552: {
		fallback: () => (__webpack_require__.e("default-node_modules_progress_kendo-angular-progressbar_fesm2022_progress-kendo-angular-progr-78f4e2").then(() => (() => (__webpack_require__(804))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-progressbar",

	},
	3421: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-svg-icons_progress_kendo-svg-icons"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-inputs_progress_kendo-angular-inputs"), __webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-angular-dropdowns_progress_kendo-angul-8da06e"), __webpack_require__.e("default-node_modules_progress_kendo-angular-pager_fesm2022_progress-kendo-angular-pager_mjs")]).then(() => (() => (__webpack_require__(8331))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-pager",

	},
	7662: {
		fallback: () => (__webpack_require__.e("node_modules_progress_kendo-data-query_dist_es2015_main_js").then(() => (() => (__webpack_require__(2248))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.7.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-data-query",

	},
	3852: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-intl_progress_kendo-intl"), __webpack_require__.e("default-node_modules_progress_pako-esm_dist_pako-esm2015_js"), __webpack_require__.e("default-node_modules_progress_kendo-angular-excel-export_fesm2022_progress-kendo-angular-exce-fdb90f")]).then(() => (() => (__webpack_require__(7111))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-excel-export",

	},
	2707: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_progress_kendo-drawing_progress_kendo-drawing"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(9349))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-angular-pdf-export",

	},
	1258: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_progress_pako-esm_dist_pako-esm2015_js"), __webpack_require__.e("node_modules_progress_kendo-drawing_dist_es2015_main_js")]).then(() => (() => (__webpack_require__(165))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.23.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@progress/kendo-drawing",

	},
	9457: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_angular_core_fesm2022__untracked-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__debug_node-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022_testing_mjs")]).then(() => (() => (__webpack_require__(4353))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/testing",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"default-webpack_sharing_consume_default_rxjs_rxjs": [
		9771
	],
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		3235
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators": [
		4315
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		8573
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http": [
		2377
	],
	"default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop": [
		5211
	],
	"default-webpack_sharing_consume_default_ngrx_signals_ngrx_signals": [
		6647
	],
	"default-webpack_sharing_consume_default_ngrx_signals_events_ngrx_signals_events": [
		8605
	],
	"default-node_modules_angular-architects_ngrx-toolkit_fesm2022_angular-architects-ngrx-toolkit_mjs": [
		7913
	],
	"default-node_modules_angular_core_fesm2022__untracked-chunk_mjs": [
		203,
		7775
	],
	"default-webpack_sharing_consume_default_angular_animations_browser_angular_animations_browser": [
		953
	],
	"default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser": [
		9476
	],
	"default-webpack_sharing_consume_default_angular_router_angular_router": [
		6289
	],
	"default-webpack_sharing_consume_default_azure_msal-browser_azure_msal-browser": [
		3960
	],
	"default-webpack_sharing_consume_default_jsverse_transloco_jsverse_transloco": [
		803
	],
	"default-webpack_sharing_consume_default_progress_kendo-angular-icons_progress_kendo-angular-icons": [
		1110
	],
	"default-webpack_sharing_consume_default_progress_kendo-angular-buttons_progress_kendo-angular-630eef": [
		8587
	],
	"default-webpack_sharing_consume_default_progress_kendo-angular-popup_progress_kendo-angular-popup": [
		1646
	],
	"default-webpack_sharing_consume_default_progress_kendo-angular-dialog_progress_kendo-angular-dialog": [
		7624
	],
	"default-webpack_sharing_consume_default_progress_kendo-angular-navigation_progress_kendo-angu-4f0499": [
		4634
	],
	"default-webpack_sharing_consume_default_progress_kendo-angular-inputs_progress_kendo-angular-inputs": [
		8141
	],
	"default-webpack_sharing_consume_default_progress_kendo-angular-indicators_progress_kendo-angu-7a54fd": [
		3310
	],
	"default-webpack_sharing_consume_default_progress_kendo-angular-dropdowns_progress_kendo-angul-8da06e": [
		8170
	],
	"default-webpack_sharing_consume_default_progress_kendo-intl_progress_kendo-intl": [
		6162
	],
	"default-webpack_sharing_consume_default_progress_kendo-angular-label_progress_kendo-angular-l-31b8bd": [
		3946,
		1409
	],
	"default-webpack_sharing_consume_default_progress_kendo-angular-dateinputs_progress_kendo-angu-fed2bb": [
		7865,
		3326,
		4159
	],
	"default-node_modules_mnp-firm-it_angular-ui-components_fesm2022_mnp-firm-it-angular-ui-compon-f35bfa": [
		6373,
		3349,
		6493,
		6235
	],
	"default-webpack_sharing_consume_default_mnp-firm-it_angular-ui-components_mnp-firm-it_angular-45e276": [
		6723
	],
	"default-webpack_sharing_consume_default_azure_msal-angular_azure_msal-angular": [
		9283
	],
	"default-webpack_sharing_consume_default_angular-architects_ngrx-toolkit_angular-architects_ng-0c86f4": [
		4749,
		5183
	],
	"default-libs_shared_ui_src_index_ts": [
		5797
	],
	"default-webpack_sharing_consume_default_progress_kendo-licensing_progress_kendo-licensing": [
		5739
	],
	"default-webpack_sharing_consume_default_progress_kendo-angular-common_progress_kendo-angular-common": [
		3857
	],
	"default-webpack_sharing_consume_default_progress_kendo-angular-l10n_progress_kendo-angular-l10n": [
		3541
	],
	"default-webpack_sharing_consume_default_progress_kendo-svg-icons_progress_kendo-svg-icons": [
		5633
	],
	"default-webpack_sharing_consume_default_angular_animations_angular_animations": [
		7767
	],
	"default-webpack_sharing_consume_default_progress_kendo-angular-utils_progress_kendo-angular-utils": [
		2807
	],
	"default-webpack_sharing_consume_default_progress_kendo-angular-intl_progress_kendo-angular-intl": [
		2291
	],
	"default-node_modules_progress_kendo-angular-dateinputs_fesm2022_progress-kendo-angular-datein-a52fab": [
		2776
	],
	"default-node_modules_progress_kendo-angular-dropdowns_fesm2022_progress-kendo-angular-dropdowns_mjs": [
		6145
	],
	"default-webpack_sharing_consume_default_progress_kendo-angular-progressbar_progress_kendo-ang-363fe1": [
		3552
	],
	"default-webpack_sharing_consume_default_progress_kendo-angular-pager_progress_kendo-angular-pager": [
		3421
	],
	"default-node_modules_progress_kendo-angular-grid_fesm2022_progress-kendo-angular-grid_mjs": [
		7662,
		3852,
		2707
	],
	"default-webpack_sharing_consume_default_progress_kendo-drawing_progress_kendo-drawing": [
		1258
	],
	"default-node_modules_ng-mocks_index_mjs": [
		9457
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}